import { CustomSubconfigurationNavigationButtons } from "../CustomSubconfigurationNavigationButtons/CustomSubconfigurationNavigationButtons";

import { Fragment, JSX } from "react";

import {
  SubconfigurationNavigationControl,
  SubconfigurationNavigationHorizontal,
  SubconfigurationNavigationOrientation,
  SubconfigurationNavigationSecondaryControl,
  SubconfigurationNavigationVertical,
  SubconfigurationStepperNavigation,
  SubconfigurationTabsNavigation,
} from "@plansoft-configuration-renderer/components";

/**
 * Components for the main navigation, i.e. tabs or stepper
 */
const NavigationComponents = {
  [SubconfigurationNavigationControl.Tabs]: SubconfigurationTabsNavigation,
  [SubconfigurationNavigationControl.Stepper]:
    SubconfigurationStepperNavigation,
  [SubconfigurationNavigationControl.None]: (): JSX.Element => <Fragment />,
};

/**
 * Components for the secondary navigation, i.e. reset, next, previous buttons
 */
const SecondaryNavigationComponents = {
  [SubconfigurationNavigationSecondaryControl.Buttons]:
    CustomSubconfigurationNavigationButtons,
  [SubconfigurationNavigationSecondaryControl.None]: (): JSX.Element => (
    <Fragment />
  ),
};

/**
 * Components for alignment of the navigation and content
 */
const AlignmentComponents = {
  [SubconfigurationNavigationOrientation.Vertical]:
    SubconfigurationNavigationVertical,
  [SubconfigurationNavigationOrientation.Horizontal]:
    SubconfigurationNavigationHorizontal,
};

/**
 * Components for the content area
 */
const ContentComponents = {
  FallbackUi: (): JSX.Element => <Fragment />,
  LoadingIndicator: (): JSX.Element => <Fragment />,
};

export const CustomSubconfigurationNavigationComponents = {
  NavigationComponents,
  SecondaryNavigationComponents,
  AlignmentComponents,
  ContentComponents,
};

export type CustomSubconfigurationNavigationComponentsType =
  typeof CustomSubconfigurationNavigationComponents;
